// ════════════════════════════════════
// useTranslation.ts — TolkX i18n Hook
// ════════════════════════════════════

import { useState,  } from 'react';
import { translations, type Lang } from './i18n';

const LANG_KEY = 'tolkx_lang';

export const useTranslation = () => {
  const [lang, setLangState] = useState<Lang>(() => {
    const saved = localStorage.getItem(LANG_KEY) as Lang;
    if (saved && translations[saved]) return saved;
    const browser = navigator.language.slice(0, 2).toUpperCase();
    return browser === 'EN' ? 'EN' : 'ES';
  });

  const setLang = (newLang: Lang) => {
    localStorage.setItem(LANG_KEY, newLang);
    setLangState(newLang);
  };

  const t = translations[lang];

  return { lang, setLang, t };
};